import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronsLeft, LogOut, User as UserIcon } from "react-feather";
import logo from "../../core/img/texas-alarms-logo.jpg";
import { useClaims } from "../../features/auth/useClaims";
import { useLogout } from "../../features/auth/useLogout";
import { paths } from "../../routes/paths";
import BranchPicker from "./BranchPicker";

const Header = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { fullName, username, roles } = useClaims();
  const logout = useLogout();

  const toggleSidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    setCollapsed((v) => !v);
  };

  const toggleMobileNav = () => {
    document.querySelector(".main-wrapper")?.classList.toggle("slide-nav");
    document.querySelector(".sidebar-overlay")?.classList.toggle("opened");
    document.querySelector("html")?.classList.toggle("menu-opened");
  };

  return (
    <div className="header">
      <div className={`header-left ${collapsed ? "" : "active"}`}>
        <Link to={paths.dashboard} className="logo logo-normal">
          <img src={logo} alt="Texas Alarms" />
        </Link>
        <Link id="toggle_btn" to="#" onClick={toggleSidebar}>
          <ChevronsLeft className="feather-16" />
        </Link>
      </div>

      <Link
        id="mobile_btn"
        className="mobile_btn"
        to="#"
        onClick={toggleMobileNav}
      >
        <span className="bar-icon">
          <span />
          <span />
          <span />
        </span>
      </Link>

      <ul className="nav user-menu align-items-center justify-content-end">
        <li className="nav-item">
          <BranchPicker />
        </li>
        <li className="nav-item dropdown has-arrow main-drop">
          <Link
            to="#"
            className="dropdown-toggle nav-link userset"
            data-bs-toggle="dropdown"
          >
            <span className="user-info">
              <span className="user-letter">
                <UserIcon size={18} />
              </span>
              <span className="user-detail">
                <span className="user-name">{fullName || username}</span>
                <span className="user-role">{roles?.[0] || ""}</span>
              </span>
            </span>
          </Link>
          <div className="dropdown-menu menu-drop-user">
            <div className="profilename">
              <div className="profileset">
                <div className="profilesets">
                  <h6>{fullName || username}</h6>
                  <h5>{roles?.[0] || ""}</h5>
                </div>
              </div>
              <hr className="m-0" />
              <button
                type="button"
                className="dropdown-item logout pb-0 border-0 bg-transparent w-100 text-start"
                onClick={logout}
              >
                <LogOut className="me-2" size={16} />
                Logout
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Header;
